<div class="header-search header-search-display-{{ display }} header-search-theme-{{ theme }}">
  <form class="header-search-form">
    <mode-global-search [theme]="theme" ></mode-global-search>
  </form>
</div>
